import { useEffect, useState } from "react";
import { subscribe } from "./liveMarket";

/**
 * Subscribes to live market data from the singleton poller.
 *
 * Pass an array of coin ids (bitcoin, ethereum, …). Returns a map keyed by id with the
 * shape: { price, changePct, up, sparkline: number[] }. Entries without data
 * yet are simply absent — callers should handle that.
 */
export function useLiveMarket(coinIds) {
  const key = coinIds.join(",");
  const [data, setData] = useState({});

  useEffect(() => {
    const update = (state) => {
      const next = {};
      for (const id of coinIds) {
        const v = state.get(id);
        if (v) next[id] = v;
      }
      setData(next);
    };
    return subscribe(update);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  return data;
}
